export default __webpack_public_path__ + "static/media/vf_logo.281dcc83.png";